/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module ADMIN REDUCER
 */

import { createSlice } from "@reduxjs/toolkit";
import { MODULE_NAME } from "./constants";

const adminSlice = createSlice({
  name: `${MODULE_NAME}`,
  initialState: {
    FirmwareInfo: {
      data: [],
      count: 0
    },
    DeviceInfo: {
      data: [],
      count: 0
    },
    station_init: null
  },
  reducers: {
    getFirmwareInfo: (state, action) => {
      state.FirmwareInfo.data = action.payload;
      return state;
    },
    getDeviceInfo: (state, action) => {
      state.DeviceInfo.data = action.payload.data;
      state.DeviceInfo.count = action.payload.total_elements;
      return state;
    },
    setStationInit: (state, action) => {
      state.station_init = action.payload.station_id;
    }
  }
});
export const adminActions = adminSlice.actions;
export const adminReducer = adminSlice.reducer;
